/* src/modules/tutors/cards/ViewDocumentswViewSignatureCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Card,
  Modal,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';

import { KeyboardArrowRight, KeyboardArrowLeft } from '@material-ui/icons';
import styles from './styles';

import { getSignature } from '../../../../config/images';
import { loadTexts } from '../../../../config/texts';

const TEXT_KEY = "tutors";

class ViewSignatureCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      open: false,
      image: '',
      tutorID: '',
      texts: loadTexts(TEXT_KEY, props.locale)
    };
    this._onNext = this._onNext.bind(this);
    this._onPrevious = this._onPrevious.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { open, tutorID } = nextProps;
    if (open && tutorID !== '') {
      // TODO: get page 0 here.
      getSignature(tutorID, 0)
        .then(res => {
          this.setState({
            open,
            page: 0,
            image: res.data,
            tutorID,
          });
        })
        .catch(() => {
          this.setState({ open, page: 0, image: '', tutorID });
        });
    } else {
      this.setState({ open, page: 0 });
    }
  }

  _onNext() {
    const { tutorID, page } = this.state;
    const nextPage = page + 1;
    getSignature(tutorID, nextPage)
      .then(res => {
        this.setState({ page: nextPage, image: res.data });
      });
  }

  _onPrevious() {
    const { tutorID, page } = this.state;
    const previousPage = page - 1;
    if (previousPage < 0) return;
    getSignature(tutorID, previousPage)
      .then(res => {
        this.setState({ page: previousPage, image: res.data });
      });
  }

  render() {
    const { onClose, classes } = this.props;
    const { open, image, page, texts } = this.state;
    return (
      <Modal
        aria-labelledby="View Documents"
        aria-describedby="View documents that tutor's uploaded"
        open={open}
        onClose={onClose}
      >
        <Card className={classes.card}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="title" color="inherit">
                {`${texts.signature.title} ${page + 1}`}
              </Typography>
            </Toolbar>
          </AppBar>
          <Typography className={classes.message}>
            {texts.signature.subtitle}
          </Typography>
          <div className={classes.content}>
            <div className={classes.buttonContainer}>
              <IconButton onClick={this._onPrevious}>
                <KeyboardArrowLeft />
              </IconButton>
            </div>
            {image !== '' && (
              <img src={image} alt={`${texts.signature.label}${page}`} className={classes.image} />
            )}
            {image === '' && ( // TODO: add xml parser for link.
              <div className={classes.blank}>
                <Typography>
                  {texts.signature.no_document}
                </Typography>
              </div>
            )}
            <div className={classes.buttonContainer}>
              <IconButton onClick={this._onNext}>
                <KeyboardArrowRight />
              </IconButton>
            </div>
          </div>
        </Card>
      </Modal>
    );
  }
}

ViewSignatureCard.propTypes = {
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  tutorID: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'ViewSignatureCard' }),
  connect(mapStateToProps, {})
)(ViewSignatureCard);



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/ViewSignatureCard/index.js